import dayjs from 'dayjs';
import { useSegmentV1ControllerSearch } from 'generated/apiComponents';
import { useSession } from 'technical/auth/client';

export const useGetSegmentData = (serialNumber: string) => {
  const { data: session } = useSession();

  const { data, error, isLoading } = useSegmentV1ControllerSearch(
    {
      queryParams: {
        serialNumber,
        projectId: session?.user.projectId ?? '',
        date: dayjs().valueOf().toString(), // used to force a new request each time
      },
    },
    {
      enabled: !!session?.user.projectId && !!serialNumber,
      retry: false,
    },
  );

  return {
    data,
    isLoading,
    error,
    isNotFound: (error as any)?.statusCode === 404,
    isServerError: (error as any)?.statusCode >= 500,
  };
};
